import {
  Box,
  Grid,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles
} from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import React from "react";
import { useDispatch } from "react-redux";
import AutoSizer from "react-virtualized/dist/commonjs/AutoSizer";
import List from "react-virtualized/dist/commonjs/List";
import { productColorsActions } from "../../actions/productColor.actions";
import MenuActions from "../MenuActions";
import ValidationModal from "../ValidationModal";

const useStyles = makeStyles((theme) => ({
  textSecondary: {
    color: "rgba(0, 0, 0, 0.54)",
  },
}));

export default function RenovColorsList(props) {
  const classes = useStyles();
  const [selectedColor, setSelectedColor] = React.useState(null);
  const [openModal, setOpenModal] = React.useState(false);
  const [deleting, setDeleting] = React.useState(false);
  const dispatch = useDispatch();

  const handleCloseMenuList = (option, productColor) => {
    if (option === "Supprimer") {
      setSelectedColor(productColor);
      setOpenModal(true);
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleColorDelete = () => {
    setDeleting(true);

    dispatch(productColorsActions.disable(selectedColor.id)).then(() => {
      setDeleting(false);
      setOpenModal(false);
    });
  };

  const _noRowsRenderer = () => {
    return (
      <div style={{ listStyle: "none" }}>
        <ListItem button style={{ height: "80px" }}>
          <ListItemText
            disableTypography
            primary={
              <Typography style={{ textAlign: "center" }}>
                Aucune finition trouvée
              </Typography>
            }
          />
        </ListItem>
        <Divider variant="inset" component="li" />
      </div>
    );
  };

  const _rowRenderer = ({ index, key, style }) => {
    const color = props.colors[index];

    return (
      <div key={key} style={{ ...style, listStyle: "none" }}>
        <ListItem
          button
          style={{ height: "80px", listStyle: "none", paddingRight: "75px" }}
        >
          <ListItemText
            disableTypography
            primary={<Typography>{color.name}</Typography>}
            secondary={
              <Box display="flex">
                <Grid className={classes.textSecondary} container>
                  <Grid item xs={4}>
                    <Typography variant={"body2"}>
                      {color.reference}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            }
          />
          <ListItemSecondaryAction>
            <MenuActions
              onClose={(evt) => handleCloseMenuList(evt, color)}
              options={{
                edit: {
                  name: "Editer",
                  link: `/renov/colors/${color.id}/edit`,
                },
              }}
            />
          </ListItemSecondaryAction>
        </ListItem>
        <Divider variant="inset" component="li" />
      </div>
    );
  };

  return (
    <div
      style={{
        height: "100%",
      }}
    >
      <ValidationModal
        loading={deleting}
        onClose={handleCloseModal}
        onClick={handleColorDelete}
        open={openModal}
        title={"Êtes-vous sûr de vouloir supprimer cette couleur ?"}
        paragraph={"Sa suppression est définitive."}
      />

      <div style={{ flex: "1 1 auto", height: "100%" }}>
        <AutoSizer>
          {({ width, height }) => {
            return (
              <List
                overscanRowCount={5}
                noRowsRenderer={_noRowsRenderer}
                rowCount={props?.colors?.length || 0}
                rowHeight={80}
                rowRenderer={_rowRenderer}
                width={width}
                height={height}
              />
            );
          }}
        </AutoSizer>
      </div>
    </div>
  );
}
